<template>
  <v-flex
    md5
    mt-15
    xs12
    new-record
  >
    <v-row>
      <v-col cols="12">
        <v-row
          justify="center"
          align="center"
        >
          <v-col>
            <v-card
              style="padding:50px"
            >
              <component :is="newIcon" />
              <h3>{{ $t('whitelabel.myWhiteLabels') }}</h3>
              <p>
                {{ $t('whitelabel.notFoundMessage1') }}
              </p>  
              <v-btn
                class="primary"
                @click="$router.push('whitelabel/create')"
              >
                {{ $t('whitelabel.createButton') }}
              </v-btn>
            </v-card> 
          </v-col>
        </v-row>  
      </v-col>
    </v-row>    
  </v-flex>
</template>

<script>

import IconWhiteLabel from '@/components/icons/IconLabel.vue'


export default {
  name: "HelperStartWhiteLabel",
 
  data: () => ({
    newIcon: IconWhiteLabel,
  }),

};
</script>

<style lang="scss" scoped>
</style>
